var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast"}},[(_vm.toast)?_c('div',{staticClass:"notification-toast"},[(_vm.toast.title)?_c('span',{staticClass:"toast-title"},[_vm._v(_vm._s(_vm.toast.title))]):_vm._e(),(_vm.toast.body)?_c('span',{staticClass:"toast-body"},[_vm._v(_vm._s(_vm.toast.body))]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }